<template lang="pug">
  .user-calendar-view.custom-container
    .section-title Calendario
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    .content
      b-container
        .table-view
          Calendar
      ListCalendar(v-if="user.role === 'owner'")
</template>

<script>
import ListCalendar from '../components/calendar/ListCalendar'
import Calendar from '../components/calendar/Calendar'
import { mapGetters, mappGeters } from 'vuex'

export default {
  components: {
    Calendar,
    ListCalendar
  },
  computed: {
    ...mapGetters('AuthenticationStore', ['user'])
  },
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Calendario',
          active:true
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.user-calendar-view {
  .header-mobile {
    display: none;
  }
  .section-title {
    margin-top: 20px;
  }
  .content {
    display: flex;
    align-items: flex-start;
    .list-calendar {
      margin-right: auto;
    }
    @media (max-width: 1200px) {
      .header-desktop {
        display: none;
      }
      .header-mobile {
        display: unset;
      }
      .list-calendar {
        margin: 1rem;
      }
      flex-wrap: wrap;
      .container {
        order: 1;
      }
    }
  }
}

</style>
